import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../../atoms/button/index.ts';
import { TickIcon, WarningIcon } from '../../../atoms/icons';

// poor-mans enum
const MERCHANT_STATUS = {
    Unconnected: 0,
    AwaitingEmailVerification: 1,
    AwaitingPaymentsEnabled: 2,
    Connected: 3,
};

const MERCHANT_STATUS_MESSAGE = {
    [MERCHANT_STATUS.AwaitingEmailVerification]: 'Awaiting email verification',
    [MERCHANT_STATUS.AwaitingPaymentsEnabled]: 'Awaiting payments enabled',
};

const PayPalMerchantStatus = function PayPalMerchantStatus({
    merchantStatus: initialMerchantStatus,
    isSuspended,
}) {
    const [isLoading, setIsLoading] = useState(false);
    const [merchantStatus, setMerchantStatus] = useState(initialMerchantStatus);

    const goToPayPalOnboardingLink = () => {
        const { host, protocol } = new URL(window.location.href);
        const onboardingUrl = `${protocol}//${host}/Services/PaypalCommerce/ReferralLink`;

        window.location.href = onboardingUrl;
    };

    const verifyStatus = () => {
        setIsLoading(true);

        fetch('/Services/PayPalCommerce/VerifyStatus', { method: 'POST', credentials: 'include' })
            .then((res) => {
                if (!res.ok) {
                    return undefined;
                }

                return res.json();
            })
            .then((json) => {
                if (json) {
                    setMerchantStatus(json);
                }

                setIsLoading(false);
            });
    };

    const disconnectPayPalAccount = () => {
        setIsLoading(true);

        fetch('/Services/PayPalCommerce/MerchantProfile', { method: 'DELETE', credentials: 'include' })
            .then((res) => {
                if (!res.ok) {
                    return undefined;
                }

                return res.json();
            })
            .then((json) => {
                if (json) {
                    setMerchantStatus(MERCHANT_STATUS.Unconnected);
                }

                setIsLoading(false);
            });
    };

    if (isSuspended) {
        return (
            <div className="layout-grouping">
                <p>Account Disabled</p>
                <Button
                    id="contact-help-desk"
                    appearance="primary"
                    href="mailto:theteam@giveeasy.org"
                    target="_blank"
                >
                    Contact Helpdesk
                </Button>
            </div>
        );
    }

    if (merchantStatus === MERCHANT_STATUS.Connected) {
        return (
            <div className="layout-grouping">
                <div className="layout-grouping layout-grouping--small">
                    <TickIcon color="#28a745" size={16} />
                    <p>Connected</p>
                </div>
                <Button
                    id="disconnect-paypal"
                    appearance="primary"
                    isLoading={isLoading}
                    disabled={isLoading}
                    onClick={disconnectPayPalAccount}
                >
                    Disconnect PayPal
                </Button>
            </div>
        );
    }

    if (merchantStatus === MERCHANT_STATUS.Unconnected) {
        return (
            <Button
                id="connect-paypal"
                appearance="primary"
                onClick={goToPayPalOnboardingLink}
            >
                Connect PayPal
            </Button>
        );
    }

    return (
        <div className="layout-grouping">
            {!isLoading && (
                <>
                    <WarningIcon color="#ffc107" size={24} />
                    <p>{MERCHANT_STATUS_MESSAGE[merchantStatus]}</p>
                </>
            )}
            <Button
                id="verify-status"
                appearance="primary"
                isLoading={isLoading}
                disabled={isLoading}
                onClick={verifyStatus}
            >
                Verify Status
            </Button>
            <Button
                id="go-to-paypal"
                appearance="primary"
                onClick={goToPayPalOnboardingLink}
            >
                Edit in PayPal
            </Button>
        </div>
    );
};

export default PayPalMerchantStatus;

PayPalMerchantStatus.propTypes = {
    merchantStatus: PropTypes.number.isRequired,
    isSuspended: PropTypes.bool.isRequired,
};
